module.exports = __webpack_public_path__ + "components/MapControl/svg/Cmentarz zabytkowy.svg?b05da8ab";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Cmentarz zabytkowy.svg
// module id = 1919
// module chunks = 0